












































import Vue from 'vue';

export default Vue.extend({
  props: ['label'],
  computed: {
    computedData(): {
      file: string;
      fileName: string;
      fileSize: string;
      fileResolution: string;
      duration: string;
      error: string;
    }[] {
      let selectedCharacteristicData = [];
      if (this.label === 'corruptedFile') {
        selectedCharacteristicData = this.$store.getters.corruptedFileList;
      } else if (this.label === 'badResolution') {
        selectedCharacteristicData = this.$store.getters.badResolutionList;
      } else if (this.label === 'badFileSize') {
        selectedCharacteristicData = this.$store.getters.badFileSizeList;
      } else if (this.label === 'badDuration') {
        selectedCharacteristicData = this.$store.getters.badDurationList;
      }

      let selectedCharacteristicDataPart = [];
      for (
        let i = 0;
        i < Math.min(30, selectedCharacteristicData.length);
        i++
      ) {
        let x = selectedCharacteristicData[i];
        selectedCharacteristicDataPart.push({
          file: x.file,
          fileName: x.file.split('/').pop(),
          fileResolution: x.width ? x.width + ' x ' + x.height : '',
          fileSize: x.file_size ? x.file_size + ' KB' : '',
          duration: x.duration ? x.duration + ' 초' : '',
          error: x.target_lib ? x.target_lib.join(', ') : '',
        });
      }

      return selectedCharacteristicDataPart;
    },
  },
  methods: {
    copyData(data: string) {
      navigator.clipboard.writeText(data).then(() => {
        this.$toast('복사되었습니다.');
      });
    },
  },
});
